module.exports = __webpack_public_path__ + "static/fonts/GodoB.9321ba9.ttf";